<div class="main">
    <div class="section">
        <div class="assign">
            {{(parentData.header == 'Assign Driver') ? ('REASSIGN.assignDriver' | translate) : (re_assign_type ==
            'both') ? ('REASSIGN.reassignBoth'
            | translate) : (re_assign_type == 'vehicle') ? ('REASSIGN.reassignVehicle' | translate):
            ('REASSIGN.reassign'
            | translate)}} | {{parentData.sin}}
            <i class="material-icons" (click)="closeAssignModal();">
                clear
            </i>
        </div>
        <div class="bodySection">
            <!-- <div class="details">
                <div class="left">
                    <div class="orgName">
                        {{orgDetails.organizationName}}
                    </div>
                    <div class="orderNo">
                        {{'REASSIGN.shipmentNo' | translate}}: 
                        {{parentData.sin}}
                    </div>
                </div>
                <div class="center">
                    <div class="startDest">
                        <div class="start" title="{{parentData.from}}">
                            {{parentData.from}}
                        </div>
                        <i class="material-icons">arrow_right_alt</i>
                        <div class="dest" title="{{parentData.to}}">
                            {{parentData.to}}
                        </div>
                    </div>

                </div>
                <div class="right">
                    <div class="vehicleType">
                        {{orgDetails.vehicleType}}
                    </div>
                    <div class="allocated">
                        Allocated: {{orgDetails.allocated}} 
                        {{'REASSIGN.toAssign' | translate}}: {{orgDetails.to_be_assigned}}
                    </div>
                </div>

            </div> -->

            <!-- <div class="header">
                {{'REASSIGN.availableTrucksDrivers' | translate}}
            </div> -->
            <div class="spot_driver_search">
                <div class="search_text">{{'ASSIGN.search' | translate}}</div>
                <div class="search_sec">
                    <div class="input-container" *ngIf="re_assign_type== 'driver' ||re_assign_type== 'both' ">
                        <input class="inputSelect" (keyup)="applyFilter($event.target.value,'mobile')"
                            [(ngModel)]="mobile_number" name="filter" placeholder="Driver Mobile No." type="number">
                        <span class="close_img" *ngIf="mobile_number" (click)="clearMobileNumber()"><i
                                class="material-icons" id="material-icons-close">
                                clear
                            </i></span>
                    </div>
                    <div class="input-container" *ngIf="re_assign_type== 'vehicle'||re_assign_type== 'both'">
                        <input class="inputSelect" (keyup)="applyFilter($event.target.value,'vehicleno')"
                            [(ngModel)]="vehicle_number" name="filter" placeholder="Vehicle No." type="text">
                        <span class="close_img" *ngIf="vehicle_number" (click)="clearVehicleNumber()"><i
                                class="material-icons" id="material-icons-close">
                                clear
                            </i></span>
                    </div>
                </div>
                <!-- <div class="toggleContainer1" *ngIf="re_assign_type == 'vehicle'||re_assign_type== 'both'">
                    <div class="toggle1" (click)="vehicleCapacity()">
                        <mat-slide-toggle >{{'ASSIGN.capacity' | translate }}</mat-slide-toggle>
                    </div>
                </div>
                <div class="toggleContainer2" *ngIf="re_assign_type == 'vehicle'||re_assign_type== 'both'">
                    <div class="toggle1" (click)="vehicleLessCapacity()">
                        <mat-slide-toggle >{{'ASSIGN.lessCapacity' | translate }}</mat-slide-toggle>
                    </div>
                </div> -->
                <div class="radioButtons">
                    <mat-radio-group aria-label="Select an option" *ngIf="re_assign_type == 'vehicle'||re_assign_type== 'both'" >
                        <div class="radio-button">
                            <mat-radio-button value="1" (click)="vehicleCapacity()">{{'ASSIGN.capacity' | translate }}</mat-radio-button>
                            <mat-radio-button value="2" (click)="vehicleLessCapacity()">{{'ASSIGN.lessCapacity' | translate }}</mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>
            </div>


            <div class="assignSection">
                <div class="tableSection">
                    <table mat-table *ngIf="assignArr.length;else noFreeDrivers" [dataSource]="assignArr" class="table">
                        <ng-container matColumnDef='select'>
                            <th mat-header-cell *matHeaderCellDef>
                                {{'REASSIGN.select' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element;let rowIndex = index;">

                                <mat-radio-button *ngIf="re_assign_type!='both'"
                                    (click)="selectRow($event, element,rowIndex)">
                                </mat-radio-button>

                                <mat-checkbox [checked]="element.select" [(ngModel)]="element.select"
                                    *ngIf="re_assign_type=='both'" [indeterminate]="element.select">
                                </mat-checkbox>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef='vehicle'>
                            <th mat-header-cell *matHeaderCellDef> {{'REASSIGN.vehicle' | translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div>
                                    {{element.vehicle}} <img src="assets/VehicleMaintenance.svg"
                                        *ngIf="element.in_service" alt="" class="icon" style="width: 15px;"
                                        title="{{'VEHICLE.in_maintenance' | translate}}">
                                </div>
                                <div style="padding:3px;margin-top:5px;color:#888; font-size:10px">
                                    {{element.vehicle_type.name}}
                                </div>
                                <div style="padding:3px;margin-top:5px;color:#888; font-size:10px">
                                    {{element.unitname}}
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef='driverName'>
                            <th mat-header-cell *matHeaderCellDef>{{'REASSIGN.driverName' | translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div>
                                    <span *ngIf="element.is_temporary">
                                        <img src="assets/spotdriver-indigo.svg" alt="" height="15px" width="15px"
                                            title="Spot Driver">
                                    </span>
                                    {{element.driverName}}
                                </div>
                                {{element.mobile}}
                                <div *ngIf="element.assigned_shipment" style="margin-top: 2px;">
                                    <div class="assigned">{{'ASSIGN.assigned' | translate}}</div>
                                    <div class="not-accepted">{{'ASSIGN.not_accepted' | translate}}</div>
                                </div>
                                <div *ngIf="!element.assigned_shipment" style="margin-top: 2px;">
                                    <div class="free">{{'ASSIGN.free' | translate}}</div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef='distance'>
                            <th mat-header-cell *matHeaderCellDef> {{'REASSIGN.distance' | translate}}</th>
                            <td mat-cell *matCellDef="let element"> {{element.distance}} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="columnHeaders; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let myRowData; columns: columnHeaders"></tr>
                    </table>
                    <mat-paginator [length]="(assignArr)? totalAssigned : 0" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                        showFirstLastButtons (page)="pageNavigate($event);"></mat-paginator>
                </div>

                <div class="map_tab">
                    <div class="mapSection">
                        <div class="label" *ngIf="viewMapFlag">
                            <div class="currentLocation">
                                <!-- {{'ASSIGN.currentLocation' | translate}} -->
                                {{(re_assign_type == 'vehicle') ? ('ASSIGN.currentLocation_vehicle' | translate) :
                                ('ASSIGN.currentLocation' | translate)}}
                            </div>
                        </div>
                        <div *ngIf="!viewMapFlag" class="btn-wrapper">
                            <button class="view-btn" (click)="viewMap()">
                             View Map
                            </button>
                         </div>
                        <div class="map" *ngIf="viewMapFlag" id="reAssignPathMap"></div>
                    </div>
                    <div class="delivery" *ngIf="viewMapFlag">
                        <div *ngFor="let delivery of deliveries; let i=index" class="pdSpan">
                            <b class="drop">D{{i+1}}</b> - {{delivery.location.name}} - {{delivery.location.city}}<br>
                            <!-- <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span> -->
                        </div>
                    </div>
                </div>

                <ng-template #noFreeDrivers>
                    <div class="noShipments" style="padding-top: 30px; text-align: center; color:#D8511F">
                        <!-- {{'REASSIGN.noFreeDrivers' | translate}} -->
                        {{(re_assign_type == 'vehicle') ? ('REASSIGN.noFreeVehicles' | translate) :
                        ('REASSIGN.noFreeDrivers' | translate)}}
                    </div>
                </ng-template>
            </div>
            <div style="display: flex;">
                <div class="spotButton" (click)="openSpotDriver();">
                    <div class="button">
                        <!-- <img src="assets/spotdriver.svg" alt=""> -->
                        <!-- <img [src]="loadImg" alt=""> -->
                        <img [src]="re_assign_type=='vehicle' ? 'assets/spotdriver.svg' : 'assets/Own-Driver.svg'"
                            alt="">
                        <span class="label">
                            {{ (re_assign_type == 'both') ? ('REASSIGN.spotBoth' | translate) : (re_assign_type ==
                            'vehicle') ? ('REASSIGN.spotVehicle'
                            | translate) : ('REASSIGN.spotDriver' | translate) }}
                        </span>
                    </div>
                </div>
                <div class="spotButton" (click)="openReAssignType();" *ngIf="re_assign_type!='both'">
                    <div class="button" id="driver_reassign">
                        <img src="assets/spotdriver-blue.svg" alt="">
                        <span class="label">
                            Add {{re_assign_type | translate}}
                        </span>
                    </div>
                </div>
                <!-- <div class="spotButton" appDbclick (debounceClick)="openOwnFleetDriver();">
                    <div class="button">
                        <img src="assets/Own-Driver.svg" alt="">
                        <span class="label">
                            {{'spotOn.addOwnFleet' | translate}}
                        </span>
                    </div>
                </div> -->
                <div class="submitButton">
                    <div class="button" (click)="assign()">
                        {{'REASSIGN.assign' | translate}}
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<ng-template #warning>
    <div class="warning">
        <div class="section">
            <div class="header">
                <div class="label">
                    {{'ASSIGN.warning' | translate}}<i class="material-icons"
                        (click)="dialogRef.close(false);">clear</i>
                </div>
            </div>
            <div class="text">
                {{inServiceVehicleNo}} {{'ASSIGN.warningText' | translate}}
            </div>
            <div class="submitButton">
                <div class="button" (click)="dialogRef.close(true);">
                    {{'ASSIGN.ok' | translate}}
                </div>
            </div>
        </div>
    </div>
</ng-template>